var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2032_1485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0219 81H3.98942C1.78785 81 0 79.2121 0 77.0106V3.98942C0 1.78785 1.78785 0 3.98942 0H61.7917C63.9933 0 65.7811 1.78785 65.7811 3.98942V32.8905C65.7811 33.4077 65.3526 33.8362 64.8355 33.8362C64.3183 33.8362 63.8898 33.4077 63.8898 32.8905V3.98942C63.8898 2.83692 62.959 1.89128 61.7917 1.89128H3.98942C2.83692 1.89128 1.89128 2.83692 1.89128 3.98942V76.9958C1.89128 78.1483 2.82215 79.0939 3.98942 79.0939H42.0219C42.5538 79.0939 42.9675 79.5224 42.9675 80.0396C42.9675 80.5567 42.539 80.9852 42.0219 80.9852V81Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8355 14.0661H0.94564C0.413718 14.0661 0 13.6376 0 13.1204C0 12.6033 0.428493 12.1748 0.94564 12.1748H64.8355C65.3674 12.1748 65.7811 12.6033 65.7811 13.1204C65.7811 13.6376 65.3526 14.0661 64.8355 14.0661Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03361 8.5555C7.87413 8.5555 8.5555 7.87413 8.5555 7.03361C8.5555 6.19309 7.87413 5.51172 7.03361 5.51172C6.19309 5.51172 5.51172 6.19309 5.51172 7.03361C5.51172 7.87413 6.19309 8.5555 7.03361 8.5555Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1215 8.5555C13.962 8.5555 14.6434 7.87413 14.6434 7.03361C14.6434 6.19309 13.962 5.51172 13.1215 5.51172C12.281 5.51172 11.5996 6.19309 11.5996 7.03361C11.5996 7.87413 12.281 8.5555 13.1215 8.5555Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2084 8.5555C20.0489 8.5555 20.7303 7.87413 20.7303 7.03361C20.7303 6.19309 20.0489 5.51172 19.2084 5.51172C18.3679 5.51172 17.6865 6.19309 17.6865 7.03361C17.6865 7.87413 18.3679 8.5555 19.2084 8.5555Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7482 80.9998C46.4844 80.9998 36.4961 71.0262 36.4961 58.7477C36.4961 46.4692 46.4696 36.4956 58.7482 36.4956C71.0267 36.4956 81.0003 46.4692 81.0003 58.7477C81.0003 71.0262 71.0267 80.9998 58.7482 80.9998ZM58.7482 38.4017C47.5335 38.4017 38.4021 47.533 38.4021 58.7477C38.4021 69.9624 47.5335 79.0937 58.7482 79.0937C69.9629 79.0937 79.0942 69.9624 79.0942 58.7477C79.0942 47.533 69.9629 38.4017 58.7482 38.4017Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1329 69.5044C55.8817 69.5044 55.6453 69.4009 55.468 69.2236L46.2184 59.9741C45.8491 59.6047 45.8491 58.9989 46.2184 58.6295C46.5878 58.2601 47.1936 58.2601 47.563 58.6295L56.1329 67.1994L71.1597 52.1726C71.5291 51.8032 72.1349 51.8032 72.5043 52.1726C72.8737 52.5419 72.8737 53.1477 72.5043 53.5171L56.8126 69.2089C56.6353 69.3862 56.3989 69.4896 56.1477 69.4896L56.1329 69.5044Z",
    fill: "#74263D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2032_1485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/Confirm.721c48ca326462edb9eab6405b3f7704.svg";
export { ForwardRef as ReactComponent };